import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: 'home'
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home.vue')
  },
  {
    path: '/policy',
    name: 'policy',
    component: () => import('@/views/policy.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 解决：*** vue项目路由跳转页面滚动条不在顶部问题 ***
router.beforeEach((to, from, next) => {
  // 在每次导航之前滚动到页面顶部
  // window.scrollTo({
  //   top: 0,
  //   behavior: 'smooth' // 可选， 使滚动平滑进行
  // })

  window.scrollTo(0,0)
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0

  next()
})

export default router
